import { Paper, PaperProps } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'PlusCard' })(theme => ({
	root: {
		padding: '36px 40px',
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		alignItems: 'center',
		boxShadow: 'none',
		boxSizing: 'border-box',
		[theme.breakpoints.up('lg')]: {
			padding: '46px 65px'
		},
		[theme.breakpoints.up('xl')]: {
			padding: '46px 120px'
		}
	},
	icon: {
		height: 70,
		marginBottom: 10
	},
	title: {
		fontWeight: 700,
		fontSize: '12px',
		lineHeight: '16px',
		textAlign: 'center',
		[theme.breakpoints.up('lg')]: {
			fontSize: '14px',
			lineHeight: '20px'
		}
	},
	description: {
		fontSize: '12px',
		lineHeight: '16px',
		textAlign: 'center',
		overflow: 'hidden',
		[theme.breakpoints.up('lg')]: {
			fontSize: '14px',
			lineHeight: '20px'
		}
	}
}));

export type PlusCardProps = PaperProps & {
	icon: string;
	title: string;
	description: string;
}

export const PlusCard = (props: PlusCardProps) => {
	const { icon, title, description, className, ...other } = props;
	const { classes, cx } = useStyles();
	return (
		<Paper data-test='plus-card' className={cx(classes.root, className)} {...other}>
			<img width={70} height={70} className={classes.icon} src={icon} alt='plus card'></img>
			<span className={classes.title}>{title}</span>
			<span className={classes.description}>{description}</span>
		</Paper>
	);
};